// As defined in https://github.com/mozilla/pdf.js/blob/master/src/shared/util.js#L378-L381
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
export default PasswordResponses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-pdf/dist/esm/PasswordResponses.js
// module id = 850
// module chunks = 0